import { render } from "./BuySample.vue?vue&type=template&id=40e67344&scoped=true"
import script from "./BuySample.vue?vue&type=script&lang=js"
export * from "./BuySample.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup.css?vue&type=style&index=0&id=40e67344&scoped=true&lang=css"
import "./BuySample.vue?vue&type=style&index=1&id=40e67344&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e67344"]])

export default __exports__